var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { CompareFareService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';
import * as FlightResultActions from '@ibe/store/actions/flight-result.actions';
import * as fromStore from '../../../../store';
import { Store } from '@ngrx/store';
import { TRIP_TYPE_MULTICITY, BASIC_ANCILLARY_CODES_FLIGHT_CHANGES, BASIC_ANCILLARY_CODES_MILES, BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE, SSR_CODE_MEAL_SNACK } from '@ibe.config';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRA_getFeatureForTAC, INDRA_getCheckedBaggageDetails } from '../../../booking/flights/brand/brand.indra';
import { takeWhile } from 'rxjs/operators';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
var INDRACompareFaresComponent = /** @class */ (function () {
    // checkIcon: string;
    // isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
    function INDRACompareFaresComponent(sanitizer, compareFareService, sidebarService, store, ancillariesService, currencyService, bookingSearchService, storageService, router) {
        this.sanitizer = sanitizer;
        this.compareFareService = compareFareService;
        this.sidebarService = sidebarService;
        this.store = store;
        this.ancillariesService = ancillariesService;
        this.currencyService = currencyService;
        this.bookingSearchService = bookingSearchService;
        this.storageService = storageService;
        this.router = router;
        this.isAlive = true;
        this.pack = [];
        this.flightFilter$ = this.store.select(fromStore.getFlightsFilterState);
        this.clickFeature = new EventEmitter();
        this.ancillariesList = [];
        this.includedAncillaries = [];
        this.features = [];
        this.isLoading = true;
        this.featureIndex = 0;
        this.ancMealLabelSegments = [];
        this.selectedInfoTACList = [];
        this.packDoneLoading = [];
        this.MILES_ANCILLARY_CODE = BASIC_ANCILLARY_CODES_MILES;
        this.CHECKED_BAG_ANCILLARY_CODE = BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE;
        this.flightsStopOverPage = false;
        this.flightsMultiCityPage = false;
        /* note: from post sprint 8 merge
        this.isCorporate$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(
                value => {
                    if (value === true) {
                        this.checkIcon = 'sprite.svg#flight--brand-checked-corp';
                    } else {
                        this.checkIcon = 'sprite.svg#flight--brand-checked';
                    }
                }
            );
        */
    }
    INDRACompareFaresComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.router.url.includes('/flights-stopover'))
            this.flightsStopOverPage = true;
        if (this.router.url.includes('/flights-multicity'))
            this.flightsMultiCityPage = true;
        this.flightFilter$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.flightFilter = value;
        });
        this.isLoading = true;
        this.pack = this.compareFareService.pack;
        var packDetail = [];
        for (var i in this.pack) {
            packDetail.push(this.INDRA_getFlightDetails(this.pack[i]));
        }
        if (packDetail) {
            var _loop_1 = function (i) {
                var significantFlightSegment = this_1.bookingSearchService.INDRA_getTAPMostSignificantFlightSegment(this_1.pack[i]);
                var haulType = significantFlightSegment ? significantFlightSegment.haul : null;
                var activePack = packDetail[i];
                var tempItinerary = [];
                var fareBasis = this_1.pack[i].options.fareFamily;
                if (this_1.flightFilter.starAlliance) {
                    fareBasis = this_1.pack[i].options.fareBasis;
                }
                for (var x in activePack.itinerary) {
                    tempItinerary.push({
                        origin: activePack.itinerary[x].origin,
                        destination: activePack.itinerary[x].destination,
                        operatingCarrier: activePack.itinerary[x].operationCarrier,
                        flightNumber: activePack.itinerary[x].flightNumber,
                        equipment: activePack.itinerary[x].equipment,
                        carrier: activePack.itinerary[x].carrier,
                        rbd: this_1.pack[i].options.rbd[0],
                        duration: activePack.itinerary[x].duration,
                    });
                }
                var request = {
                    origin: activePack['origin'],
                    destination: activePack['destination'],
                    fareBasis: fareBasis,
                    fareFamily: this_1.pack[i].options.fareFamily,
                    marketingCarrier: activePack['carrier'],
                    tripType: TRIP_TYPE_MULTICITY,
                    itinerary: tempItinerary
                };
                sessionStorage.removeItem('ancMealLabelSegments');
                this_1.INDRA_getAncillaryListByBrand(request, i).subscribe(function (data) {
                    if (data.status == '200') {
                        if (data.fareInformationData && Object.keys(data.fareInformationData).length !== 0) {
                            var indexesTAC = Object.keys(data.fareInformationData);
                            var hasMealChecker_1 = [];
                            var hasAncHasMealDataStore_1;
                            var hasAncHasNoMealDataStore_1;
                            _this.selectedInfoTACList[i] = data.fareInformationData[0];
                            indexesTAC.map(function (index) {
                                var fareInfoData = data.fareInformationData[index];
                                if (fareInfoData['basic-ancillaries'] &&
                                    fareInfoData['basic-ancillaries'].length > 0) {
                                    fareInfoData['ancillaries'].map(function (data) {
                                        if (data == 'MEALS') {
                                            hasMealChecker_1.push(true);
                                            hasAncHasMealDataStore_1 = fareInfoData;
                                        }
                                        else {
                                            hasMealChecker_1.push(false);
                                            hasAncHasNoMealDataStore_1 = fareInfoData;
                                        }
                                    });
                                }
                                else {
                                    return;
                                }
                            });
                            var inDirectFlight = _this.pack[i].listSegment.length > 1;
                            if (hasMealChecker_1.includes(true)) {
                                _this.packDoneLoading.push(true);
                                _this.INDRA_mapAncillaries(i, hasAncHasMealDataStore_1['ancillaries'], hasAncHasMealDataStore_1['basic-ancillaries'], hasAncHasMealDataStore_1['red-and-green-elegible'], haulType, hasAncHasMealDataStore_1['miles'], inDirectFlight);
                            }
                            else {
                                if (hasAncHasNoMealDataStore_1) {
                                    _this.packDoneLoading.push(true);
                                    _this.INDRA_mapAncillaries(i, hasAncHasNoMealDataStore_1['ancillaries'], hasAncHasNoMealDataStore_1['basic-ancillaries'], hasAncHasNoMealDataStore_1['red-and-green-elegible'], haulType, hasAncHasNoMealDataStore_1['miles'], inDirectFlight);
                                }
                                else {
                                    return;
                                }
                            }
                        }
                    }
                }, function (error) {
                    _this.isLoading = false;
                });
            };
            var this_1 = this;
            for (var i in packDetail) {
                _loop_1(i);
            }
        }
    };
    INDRACompareFaresComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRACompareFaresComponent.prototype.INDRA_getBrandFeatures = function () {
        var includedFeatures = this.features[this.featureIndex];
        this.featureIndex++;
        if (this.featureIndex > this.features.length) {
            this.featureIndex = 0;
            return this.features[this.featureIndex];
        }
        else {
            return includedFeatures;
        }
    };
    INDRACompareFaresComponent.prototype.INDRA_getBrandImage = function (brand) {
        var imageFile;
        var isLongHaul = true;
        switch (brand) {
            case 'discount':
            case 'basic':
                imageFile = 'green.jpg';
                break;
            case 'classic':
            case 'plus':
                imageFile = 'red.gif';
                break;
            case 'executive':
            case 'top-executive':
                if (isLongHaul)
                    imageFile = 'executive-seat.jpg';
                else
                    imageFile = 'red-bigsize.jpg';
                break;
            default:
                // TODO - Default image
                imageFile = '';
                break;
        }
        var url = 'url(assets/images/brands/' + imageFile + ')';
        return this.sanitizer.bypassSecurityTrustStyle(url);
    };
    /**
     * Wrapper for @feature icon
     * @param feature
     */
    INDRACompareFaresComponent.prototype.INDRA_featureIcon = function (feature) {
        return feature.icon;
    };
    INDRACompareFaresComponent.prototype.INDRA_featureType = function (feature) {
        if (feature.extra) {
            var ngClass = { extra: true };
            ngClass[feature.type] = true;
            return ngClass;
        }
        return feature.type;
    };
    INDRACompareFaresComponent.prototype.INDRA_featureLabel = function (feature) {
        if (feature.extra)
            return feature.extra.label;
        return feature.label;
    };
    INDRACompareFaresComponent.prototype.INDRA_featureExtra = function (feature) {
        return feature.extra ? feature.extra : false;
    };
    INDRACompareFaresComponent.prototype.INDRA_featureIsAdded = function (feature) {
        return feature.type === 'added';
    };
    INDRACompareFaresComponent.prototype.INDRA_featureIsAvailable = function (feature) {
        return feature.type === 'available';
    };
    INDRACompareFaresComponent.prototype.INDRA_featurePrice = function (feature) {
        return feature.price;
    };
    INDRACompareFaresComponent.prototype.INDRA_handleTicketConditionsClick = function (flight, feature, infoTacIndex) {
        var airportTranslationData = this.storageService.get('airportTranslationData');
        //METHOD: SET THE "selectedInfoTAC" ON STORE BASED ON THE SELECTED INFORMATION TAC
        if (this.selectedInfoTACList && this.selectedInfoTACList.length > 0) {
            var selectedInfoTAC_1;
            this.selectedInfoTACList.map(function (infoTac, index) {
                var _a;
                if (index === infoTacIndex) {
                    selectedInfoTAC_1 = {
                        "fare-information": (_a = {},
                            _a[flight.idFlight] = infoTac,
                            _a),
                        airport: airportTranslationData
                    };
                }
            });
            this.storageService.set('selectedInfoTAC', selectedInfoTAC_1);
        }
        this.ancMealLabelSegments = [];
        this.store.dispatch(new FlightResultActions.PutSelectedFlightAction(flight));
        this.sidebarService.openSidebar([
            feature['flight_details'].route,
            {
                flight: flight.idFlight,
                brand: flight.options.brand,
                feature: feature['id']
            }
        ], [{ flightInfo: flight, feature: feature }]);
        var transFlightData = __assign({}, flight, { cabin: this.INDRA_checkCabinType(flight.options.brand), mixedCabins: flight.options && flight.options.lenght > 1 ? this.INDRA_checkMixedCabins(flight.options) : false, brandCode: flight.options.brand, fareFamily: flight.options && flight.options.fareFamily.length > 0 ? flight.options.fareFamily[0] : null });
        this.storageService.set('availabilityFlightData', transFlightData);
    };
    INDRACompareFaresComponent.prototype.INDRA_checkCabinType = function (brandCode) {
        var cabinType = '';
        switch (brandCode) {
            case 'executive':
            case 'top-executive':
                cabinType = 'Executive';
                break;
            case 'discount':
            case 'basic':
            case 'classic':
            case 'plus':
                cabinType = 'Economy';
                break;
            case 'milesgo-economy':
            case 'miles&go-extra':
            case 'miles&go-executive':
                cabinType = 'Economy/Executive';
                break;
            case 'star_alliance-economy':
            case 'star_alliance-business':
            case 'star_alliance-first':
            default:
                break;
        }
        return cabinType;
    };
    INDRACompareFaresComponent.prototype.INDRA_checkMixedCabins = function (cabins) {
        return !(cabins.every(function (v) { return v === cabins[0]; }));
    };
    INDRACompareFaresComponent.prototype.INDRA_getFlightDetails = function (flight) {
        if (flight) {
            var flightDetail = {
                destination: null,
                carrier: null,
                origin: null,
                itinerary: [],
                listSegment: []
            };
            var segmentLength = flight.listSegment.length;
            flightDetail['destination'] = flight.listSegment[segmentLength - 1].arrivalAirport;
            flightDetail['carrier'] = flight.listSegment[0].carrier;
            flightDetail['origin'] = flight.listSegment[0].departureAirport;
            flightDetail['itinerary'] = [];
            for (var i in flight.listSegment) {
                flightDetail.itinerary[i] = {
                    equipment: flight.listSegment[i].equipment,
                    carrier: flight.listSegment[i].carrier,
                    operationCarrier: flight.listSegment[i].operationCarrier,
                    flightNumber: flight.listSegment[i].flightNumber,
                    origin: flight.listSegment[i].departureAirport,
                    destination: flight.listSegment[i].arrivalAirport,
                    duration: flight.listSegment[i].duration,
                };
            }
            return flightDetail;
        }
        return null;
    };
    INDRACompareFaresComponent.prototype.INDRA_getAncillaryListByBrand = function (request, activePackIndex) {
        var response = null;
        response = this.ancillariesService.INDRA_getFareInformationTAC(request);
        this.INDRA_getMealAncSegments(response, this.pack[activePackIndex]);
        return response;
    };
    INDRACompareFaresComponent.prototype.INDRA_getMealAncSegments = function (infoTACData, selFlightData) {
        var _this = this;
        infoTACData
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (data) {
            var fareInfoData = data['fareInformationData'];
            var ancMealSegments = [];
            if (fareInfoData && Object.keys(fareInfoData).length > 0) {
                Object.keys(fareInfoData).map(function (ancSeg) {
                    if (fareInfoData[ancSeg].ancillaries.includes('MEALS')) {
                        ancMealSegments.push(ancSeg);
                    }
                });
                if (ancMealSegments && ancMealSegments.length > 0) {
                    ancMealSegments.map(function (seg) {
                        var isForStopOver = _this.flightsStopOverPage || _this.flightsMultiCityPage
                            ? fareInfoData[seg].ancillaries
                            : fareInfoData[seg].includedAncillaries;
                        var hasSnack = false;
                        hasSnack = isForStopOver.includes(SSR_CODE_MEAL_SNACK);
                        if (!hasSnack) {
                            hasSnack = isForStopOver.find(function (res) { return res.code === SSR_CODE_MEAL_SNACK; }) ? true : false;
                        }
                        _this.ancMealLabelSegments.push({
                            flightId: selFlightData.idFlight,
                            route: selFlightData.listSegment[seg] ? selFlightData.listSegment[seg].departureAirport + '-' + selFlightData.listSegment[seg].arrivalAirport : '',
                            idSegment: selFlightData.listSegment[seg] ? selFlightData.listSegment[seg].idInfoSegment : '',
                            fareFamily: selFlightData.options.fareFamily,
                            hasSnack: hasSnack,
                            mealImageBySegment: fareInfoData[seg].mealImageBySegment,
                            mealImage: fareInfoData[seg].mealImage,
                        });
                    });
                }
            }
            sessionStorage.setItem('ancMealLabelSegments', JSON.stringify(_this.ancMealLabelSegments));
        });
    };
    INDRACompareFaresComponent.prototype.INDRA_getFareInfoTACData = function () {
        return this.infoTACData;
    };
    INDRACompareFaresComponent.prototype.INDRA_mapAncillaries = function (packIndex, includedAncillaries, ancillariesList, redAndGreenEligibleRoute, haulType, miles, inDirectFlight) {
        // this.features.push(ancillariesList.filter(ancillary => ancillary.available && ancillary.free).map(
        // 	ancillary => this.INDRA_composeFeature(ancillary, includedAncillaries, redAndGreenEligibleRoute, haulType, miles, inDirectFlight)));
        var _this = this;
        this.features[packIndex] = ancillariesList.filter(function (ancillary) { return ancillary.available && ancillary.free; })
            .map(function (ancillary) { return _this.INDRA_composeFeature(ancillary, includedAncillaries, redAndGreenEligibleRoute, haulType, miles, inDirectFlight); });
        // if (this.features.length == this.pack.length) {
        // 	this.isLoading = false;
        // }
        if (this.features.length == this.packDoneLoading.length) {
            this.isLoading = false;
        }
    };
    INDRACompareFaresComponent.prototype.INDRA_composeFeature = function (ancillary, includedAncillaries, redAndGreenEligibleRoute, haulType, miles, inDirectFlight) {
        var labelPrefix = '';
        if (ancillary.code === BASIC_ANCILLARY_CODES_FLIGHT_CHANGES && ancillary.free) {
            labelPrefix = 'Free';
        }
        var featureTemplate = INDRA_getFeatureForTAC(ancillary.code, this.pack[0].options.brand, redAndGreenEligibleRoute, haulType, inDirectFlight);
        var includedAncillaryList = this.ancillariesService.getAncillaryIncludedPerBasicAncillary(ancillary.code, includedAncillaries);
        var feature = {
            id: featureTemplate.id,
            code: ancillary.code,
            label: labelPrefix ? labelPrefix + ' ' + featureTemplate.label : featureTemplate.label,
            labelTranslationKey: labelPrefix ? featureTemplate.labelTranslationKey + labelPrefix : featureTemplate.labelTranslationKey,
            type: (ancillary.free ? 'added' : (ancillary.available ? 'available' : 'unavailable')),
            extra: false,
            icon: featureTemplate.icon,
            price: ancillary.amount,
            currency: ancillary.currency,
            description: ancillary.available ? featureTemplate.description : '',
            details: featureTemplate.details,
            flight_details: featureTemplate.flight_details,
            includedAncillaries: includedAncillaryList,
            amountLabel: this.INDRA_getAmountLabel(ancillary.code, miles, includedAncillaryList)
        };
        return feature;
    };
    INDRACompareFaresComponent.prototype.INDRA_getCurrency = function (feature) {
        return feature.currency ? this.currencyService.INDRA_getCurrencySymbol(feature.currency).unit : '';
    };
    INDRACompareFaresComponent.prototype.INDRA_getAmountLabel = function (featureCode, miles, includedAncillaryList) {
        var amount;
        if (featureCode === BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE && includedAncillaryList && includedAncillaryList.length > 0) {
            // checked baggage bag count
            var holdBaggageAncillaryCode = includedAncillaryList[0];
            var ancillaryBaggageDetails = INDRA_getCheckedBaggageDetails(holdBaggageAncillaryCode);
            if (ancillaryBaggageDetails) {
                amount = ancillaryBaggageDetails.count;
            }
        }
        else if (featureCode === BASIC_ANCILLARY_CODES_MILES && miles !== null && miles > 0) {
            // miles to be earned by taking the flight
            amount = miles;
        }
        return amount;
    };
    return INDRACompareFaresComponent;
}());
export { INDRACompareFaresComponent };
